module.exports = __webpack_public_path__ + "10ae39c56a4a43ff1177029b7e1c51c2.svg";